import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import { useAuthStore } from '../store/authStore'
import { set_token_getter } from '../lib/back_app'
import back_app from '../lib/back_app'

export const POST_AUTH_REDIRECT_KEY = 'post_auth_redirect'

export function useAuth() {
  const { user: auth0_user, isAuthenticated, isLoading,
    getAccessTokenSilently } = useAuth0()
  const { setUser, setLoading, set_email_unverified,
    set_needs_onboarding, set_org_disabled, set_orgs } = useAuthStore()
  const navigate = useNavigate()

  useEffect(() => {
    set_token_getter(() =>
      getAccessTokenSilently({authorizationParams: {prompt: 'none'}}))
  }, [getAccessTokenSilently])

  useEffect(() => {
    if (isLoading)
      return
    if (!isAuthenticated || !auth0_user) {
      setUser(null)
      set_email_unverified(false)
      set_needs_onboarding(false)
      set_org_disabled(false)
      setLoading(false)
      return
    }
    let cancelled = false
    let poll_id: any = null
    const init = async () => {
      const is_unverified = (r: any) =>
        r?.err == 'email not verified' || r?.err_data?.err == 'email not verified'
      try {
        const email = auth0_user.email || ''
        let user_full = await back_app.user_get(email)
        if (is_unverified(user_full)) {
          if (cancelled)
            return
          set_email_unverified(true)
          setLoading(false)
          poll_id = setInterval(async () => {
            let r = await back_app.user_get(email)
            if (is_unverified(r))
              return
            clearInterval(poll_id)
            poll_id = null
            window.location.reload()
          }, 2000)
          return
        }
        set_email_unverified(false)
        if (user_full.err)
          user_full = await back_app.user_init(email)
        if (cancelled)
          return
        const sel_org = user_full?.orgs?.[user_full?.org_id_select]
        const orgs_map: Record<string, {id: string, lbl: string, logo_url?: string}> = {}
        for (const oid in (user_full?.orgs || {})) {
          const o = user_full.orgs[oid]
          if (!o)
            continue
          orgs_map[oid] = {id: o.id || oid, lbl: o.lbl || oid, logo_url: o.logo_url}
        }
        set_orgs(orgs_map, user_full.org_id_select || '')
        if (!sel_org?.flag?.is_brand && !sel_org?.flag?.is_creator) {
          set_needs_onboarding(true)
          set_org_disabled(false)
          setLoading(false)
          return
        }
        set_needs_onboarding(false)
        if (sel_org?.is_disable) {
          set_org_disabled(true)
          setLoading(false)
          return
        }
        set_org_disabled(false)
        const user_type = sel_org?.flag?.is_brand ? 'brand' : 'creator'
        const org = sel_org
        setUser({
          id: user_full.id || auth0_user.sub || '',
          email,
          user_type,
          full_name: user_full.first
            ? (user_full.first + ' ' + (user_full.last || '')).trim()
            : user_full.nick || auth0_user.name || '',
          ts: {insert: user_full.ts?.insert || '', modified: user_full.ts?.modified || ''},
          org_id: org?.id || user_full.org_id_select || '',
          org_id_select: user_full.org_id_select || '',
          orgs: orgs_map,
        })
        let redirect = localStorage.getItem(POST_AUTH_REDIRECT_KEY)
        if (redirect) {
          localStorage.removeItem(POST_AUTH_REDIRECT_KEY)
          let target = redirect == 'dashboard'
            ? (user_type == 'brand' ? '/brand/dashboard' : '/creator/dashboard')
            : redirect
          navigate(target, {replace: true})
        }
      } catch (err) {
        console.error('user init error:', err)
        if (cancelled)
          return
      }
      setLoading(false)
    }
    init()
    return () => {
      cancelled = true
      if (poll_id)
        clearInterval(poll_id)
    }
  }, [isAuthenticated, isLoading, auth0_user])
}